import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgProgressModule } from "@ngx-progressbar/core";

import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app.routing";
import { ComponentsModule } from "./components/components.module";
import { AppComponent } from "./app.component";
import { AgmCoreModule } from "@agm/core";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";

import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { ActionReducer, MetaReducer, StoreModule } from "@ngrx/store";
// import { reducers, metaReducers } from './reducers';
import { environment } from "environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { ToastrModule } from "ngx-toastr";
import { AuthEffects } from "./modules/auth/_state/auth.effects";
import { AuthInterceptor } from "./modules/auth/_services/auth.interceptor.service";
import { SharedModule } from "./shared/shared.module";
import { ProductsEffects } from "./modules/products/_state/products.effects";
import { TransactionsEffects } from "./modules/transactions/_state/txn.efffects";
import { BulkPayEffects } from "./modules/bulk-pay/_state/bulk-pay.effects";
import { AuthorizerEffects } from "./modules/authorizers/_state/authorizers.effects";
import { DashboardEffects } from "./modules/dashboard/_state/dashboard.effects";
import { NotificationsEffects } from "./modules/notifications/_state/notifications.effects";
import { SettingsEffects } from "./modules/settings/_state/settings.effects";
import { CustomerEffects } from "./modules/customers/_state/customers.effects";
import { FeeEffects } from "./modules/fee-sharing/_state/fee-sharing.effects";
import { StaffEffects } from "./modules/fwp/_state/staffs.effects";
import { PayrollEffects } from "./modules/payroll/_state/payroll.effects";
import { DeveloperEffects } from "./modules/settings/developer-page/_state/developer.effects";
import { metaReducers, reducers } from "./reducers";

// console.log all actions
// export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
//   return function(state, action) {
//     console.log('state', state);
//     console.log('action', action);

//     return reducer(state, action);
//   };
// }

// export const metaReducers: MetaReducer<any>[] = [debug];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    SharedModule,
    AppRoutingModule,
    NgProgressModule,
    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "YOUR_GOOGLE_MAPS_API_KEY",
    }),
    EffectsModule.forRoot([
      AuthEffects,
      DashboardEffects,
      ProductsEffects,
      StaffEffects,
      PayrollEffects,
      TransactionsEffects,
      BulkPayEffects,
      AuthorizerEffects,
      NotificationsEffects,
      SettingsEffects,
      CustomerEffects,
      FeeEffects,
      DeveloperEffects,
    ]),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    ...(!environment.production ? [StoreDevtoolsModule.instrument({ maxAge: 25 })] : []),
  ],
  declarations: [AppComponent, AdminLayoutComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService) {
  return async () => {
    translate.setDefaultLang("en");
    await translate.use("fr").toPromise();
    await translate.use("es").toPromise();
    await translate.use("pt").toPromise();
    const returnValue = await translate.use("en").toPromise();
    return returnValue;
  };
}
